import React, { useEffect, useState } from 'react';

export const CountdownTimer = ({ initialTime, onEnded }: { initialTime: number, onEnded: () => void }) => {
    const [timeLeft, setTimeLeft] = useState<number>(initialTime);

    useEffect(() => {
        if (timeLeft === 0) return onEnded?.();

        const interval = setInterval(() => {
            setTimeLeft(prevTime => prevTime - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [timeLeft]);

    return (
        <span>{timeLeft}</span>
    );
};
